import { Injectable } from '@angular/core';
import { SessionStorageService } from './session_storage';
import { P30APIService } from './api';
import { NzMessageService } from 'ng-zorro-antd/message';
import { BehaviorSubject, combineLatest, isEmpty, map, of } from 'rxjs';
import { IFCGroupsDTO } from '../interfaces/ifcReviewers';
import { IFCCOMPTROLLERS, IFCComptrollersGroupName, IFCCreateSuccess, IFCDueDateUpdateError, IFCDueDateUpdateSuccess, IFCGOVERNANCE, IFCGovernanceGroupName, IFCLEGAL, IFCLegalGroupName, IFCSecretaryGroupName, IFCTAX, IFCTaxGroupName, IFCTREASURY, IFCTreasuryGroupName, LOCALBU, LocalBUGroupName, LOCALCOMPTROLLERS, LocalComptrollersGroupName, LocalIFCCreateSuccess, LOCALLEGAL, LocalLegalGroupName, LOCALOTHERS, LocalOthersGroupName, LOCALTAX, LocalTaxGroupName, LOCALTREASURY, LocalTreasuryGroupName, PROPOSAL_ID, REQUESTOR } from 'src/app/constants/constants';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { LocalIFCGroupsDTO } from '../interfaces/LocalIFCReviewer';


@Injectable({
  providedIn: 'root',
})
export class DataServiceIFCReviewers {
  ifcReviewersPayload$ = new BehaviorSubject<IFCGroupsDTO[]>([]);
  localReviewersPayload$ = new BehaviorSubject<IFCGroupsDTO[]>([]);
  isConcurDateEmpty$ = new BehaviorSubject<boolean>(true);
  isLocalConcurDateEmpty$ = new BehaviorSubject<boolean>(true);
  isRecordsToUpdate$ = new BehaviorSubject<boolean | undefined>(undefined);
  isLocalRecordsToUpdate$ = new BehaviorSubject<boolean | undefined>(undefined);
  isReviewSubmitClicked$ = new BehaviorSubject<boolean | undefined>(undefined);
  private errorMsgSource = new BehaviorSubject<string>('');
  errorMsg$ = this.errorMsgSource.asObservable();

  isActionCompletd!: boolean;
  isLocalActionCompletd!: boolean;

  constructor(
    private session: SessionStorageService,
    private apiService: P30APIService,
    private message: NzMessageService
  ) { }
  setErrorMsg(msg: string) {
    this.errorMsgSource.next(msg);    
  }
  reviewersPayload(state: IFCGroupsDTO[]) {
    this.ifcReviewersPayload$.next(state);
  }

  ifcConcurDateValue(state: boolean) {
    this.isConcurDateEmpty$.next(state);
  }

  getIFCUpdateRecordsStatus(state: boolean | undefined) {
    this.isRecordsToUpdate$.next(state);
  }
  reviewNsubmitStatus(state: boolean | undefined) {
    this.isReviewSubmitClicked$.next(state);
  }

  reviewAndValidateIfcReviewers(form: UntypedFormGroup): Promise<boolean> {
    const control = form.controls["dueDate"];
    control.setValidators([Validators.required]);
    control.markAsDirty();
    control.updateValueAndValidity();
    return Promise.resolve(form.valid);
  }

  async defaultGroupMemberAPICall() {
    return this.apiService.getReviewers().pipe(
      map((data: any) => {
        if (data) return data;
      })
    );
  }

  async getIFCApprovals() {
    const proposal_ID = this.session.getItem(PROPOSAL_ID);
    return this.apiService.getApprovals(proposal_ID).pipe(
      map((approvals: any) => {
        if (approvals) return approvals;
      })
    );
  }

  async submitIfcForApproval(form: any) {
    let approvalsid: IFCGroupsDTO[] = [];
    console.log('Submitting IFC reviewers form ',form);
    console.log('Submitting IFC reviewers this.session.getItem(PROPOSAL_ID) ',this.session.getItem(PROPOSAL_ID));
    this.apiService.getApprovals(this.session.getItem(PROPOSAL_ID)).subscribe({
      next: (approval) => {
        if (approval.body) {
          approvalsid = approval.body;
          console.log('getApprovals response ',approval);
          approvalsid = approvalsid?.filter(x => (x.type.toString().toLocaleLowerCase() == IFCComptrollersGroupName 
                                               || x.type.toString().toLocaleLowerCase() == IFCGovernanceGroupName 
                                               || x.type.toString().toLocaleLowerCase() == IFCTreasuryGroupName 
                                               || x.type.toString().toLocaleLowerCase() == IFCLegalGroupName 
                                               || x.type.toString().toLocaleLowerCase() == IFCTaxGroupName
                                               || x.type.toString().toLocaleLowerCase() == IFCSecretaryGroupName));
          if (approvalsid.length > 0) {
            this.updateDueDateForAllGroups();
            this.getIFCUpdateRecordsStatus(true);
          } else {
            this.createIFCApproval();
            this.getIFCUpdateRecordsStatus(true);
          }
        }
        else {
          this.createIFCApproval();
          this.getIFCUpdateRecordsStatus(true);
        }
      }
    })
  }

  async createIFCApproval() {
    let responseStatus: boolean;
    let payload: IFCGroupsDTO[] = [];
    let Proposal_ID = this.session.getItem(PROPOSAL_ID);
    this.ifcReviewersPayload$.subscribe((value: IFCGroupsDTO[]) => {
      payload = value;
    });
    console.log('Creating IFC reviewers payload ',payload);
    //await this.apiService.createApprovals(Proposal_ID, payload[0]);
    let legal = this.apiService.createApprovals(Proposal_ID, payload[0]);
    let comptrollers = this.apiService.createApprovals(Proposal_ID, payload[1]);
    let tax = this.apiService.createApprovals(Proposal_ID, payload[2]);
    let treasury = this.apiService.createApprovals(Proposal_ID, payload[3]);
    let governance = this.apiService.createApprovals(Proposal_ID, payload[4]);
    let secretery = this.apiService.createApprovals(Proposal_ID, payload[5]);
    combineLatest([legal, comptrollers, tax, treasury, governance, secretery]).subscribe((result: any) => {
      this.isActionCompletd = false;
      responseStatus = result.every((res: any) => Number(res.status) == 200 || Number(res.status) == 201);
      if (responseStatus) {
        this.message.success(IFCCreateSuccess);
      } else {
        this.message.error(IFCDueDateUpdateError);
      }
    })
  }

  async updateDueDateForAllGroups() {
    let responseStatus: boolean;
    let payload: IFCGroupsDTO[] = [];
    this.ifcReviewersPayload$.subscribe((value: IFCGroupsDTO[]) => {
      payload = value;
      return payload
    });
    let proposal_ID = this.session.getItem(PROPOSAL_ID);
    let legal = await this.apiService.updateApprovals(proposal_ID, Number(payload[0]?.approvalsId), payload[0]);
    let comptrollers = await this.apiService.updateApprovals(proposal_ID, Number(payload[1]?.approvalsId), payload[1]);
    let tax = await this.apiService.updateApprovals(proposal_ID, Number(payload[2]?.approvalsId), payload[2]);
    let treasury = await this.apiService.updateApprovals(proposal_ID, Number(payload[3]?.approvalsId), payload[3]);
    let governance = await this.apiService.updateApprovals(proposal_ID, Number(payload[4]?.approvalsId), payload[4]);
    let secretery = await this.apiService.updateApprovals(proposal_ID, Number(payload[5]?.approvalsId), payload[5]);
    combineLatest([legal, comptrollers, tax, treasury, governance, secretery]).subscribe((result: any) => {
      this.isActionCompletd = false;
      responseStatus = result.every((res: any) => Number(res.status) == 200 || Number(res.status) == 201);
      if (responseStatus) {
        this.message.success(IFCDueDateUpdateSuccess);
      } else {
        this.message.error(IFCDueDateUpdateError);
      }
    })
  }

  updateIFCApproval(type: string) {
    let payload: IFCGroupsDTO[] = [];
    let Proposal_ID = this.session.getItem(PROPOSAL_ID);
    this.ifcReviewersPayload$.subscribe((value: IFCGroupsDTO[]) => {
      payload = value;
    });
    switch (type) {
      case IFCLEGAL: {
        let payload_data: IFCGroupsDTO = payload[0]
        payload_data.status = null;
        payload_data.comment = '';
        this.apiService.updateApprovals(Proposal_ID, Number(payload[0]?.approvalsId), payload_data).subscribe(legal => {
          if (legal.body) {
            console.log("this is legal response => ", legal);
          }
        });
        break;
      }
      case IFCCOMPTROLLERS: {
        let payload_data: IFCGroupsDTO = payload[1]
        payload_data.status = null;
        payload_data.comment = '';
        this.apiService.updateApprovals(Proposal_ID, Number(payload[1]?.approvalsId), payload_data).subscribe(comptroller => {
          if (comptroller.body) {
            console.log("this is comptroller response => ", comptroller);
          }
        });
        break;
      }
      case IFCTAX: {
        let payload_data: IFCGroupsDTO = payload[2]
        payload_data.status = null;
        payload_data.comment = '';
        this.apiService.updateApprovals(Proposal_ID, Number(payload[2]?.approvalsId), payload_data).subscribe(tax => {
          if (tax.body) {
            console.log("this is tax response => ", tax);
          }
        });
        break;
      }
      case IFCTREASURY: {
        let payload_data: IFCGroupsDTO = payload[3]
        payload_data.status = null;
        payload_data.comment = '';
        this.apiService.updateApprovals(Proposal_ID, Number(payload[3]?.approvalsId), payload_data).subscribe(treasury => {
          if (treasury.body) {
            console.log("this is treasury response => ", treasury);
          }
        });
        break;
      }
      case IFCGOVERNANCE: {
        let payload_data: IFCGroupsDTO = payload[4]
        payload_data.status = null;
        payload_data.comment = '';
        this.apiService.updateApprovals(Proposal_ID, Number(payload[4]?.approvalsId), payload_data).subscribe(governance => {
          if (governance.body) {
            console.log("this is governance response => ", governance);
          }
        });
        break;
      }
    }

  }

  //#region For Local Reviewver Role
  localReviewersPayload(state: IFCGroupsDTO[]) {
    this.localReviewersPayload$.next(state);
  }

  localConcurDateValue(state: boolean) {
    this.isLocalConcurDateEmpty$.next(state);
  }

  getLocalUpdateRecordsStatus(state: boolean | undefined) {
    this.isLocalRecordsToUpdate$.next(state);
  }

  reviewAndValidateLocalReviewers() {
    this.setErrorMsg("");
    let payload: LocalIFCGroupsDTO[] = [];
    this.localReviewersPayload$.subscribe((value: LocalIFCGroupsDTO[]) => {
      payload = value;
    });
    // Do we need at least one approver is required if the toggle button "Local Reviewers Required" is Yes ?
    if (payload.length > 0) {
       const validReviewers = payload.filter(
        x => (
          (x.type != "" && x.approverEmail.length > 0) &&
          (x.dueDate != null && x.dueDate !== "")
        ));
      if (validReviewers.length > 0) {
        return true;
      } 
      else {
        this.setErrorMsg("LOCAL_REVIEWER_ERROR");
        return false;
      }
    }
    else {
      if (this.session.getItem("userRole").roleTitle == REQUESTOR)
        return true;
      this.setErrorMsg("LOCAL_REVIEWER_ERROR");
      return false;
    }
  }

  async defaultLocalGroupMemberAPICall() {
    return this.apiService.getReviewers().pipe(
      map((data: any) => {
        if (data) return data;
      })
    );
  }

  async getLocalApprovals() {
    const proposal_ID = this.session.getItem(PROPOSAL_ID);
    return this.apiService.getApprovals(proposal_ID).pipe(
      map((approvals: any) => {
        if (approvals) return approvals;
      })
    );
  }

  async submitLocalForApproval(form: any) {

    let approvalsid: IFCGroupsDTO[] = [];
    this.apiService.getApprovals(this.session.getItem(PROPOSAL_ID)).subscribe({
      next: (approval) => {
        if (approval.body) {
          approvalsid = approval.body;
          approvalsid = approvalsid?.filter(x => (x.type.toString().toLocaleLowerCase() == LocalLegalGroupName || x.type.toString().toLocaleLowerCase() == LocalComptrollersGroupName || x.type.toString().toLocaleLowerCase() == LocalTaxGroupName || x.type.toString().toLocaleLowerCase() == LocalBUGroupName || x.type.toString().toLocaleLowerCase() == LocalOthersGroupName || x.type.toString().toLocaleLowerCase() == LocalTreasuryGroupName));
          if (approvalsid.length > 0) {
            this.updateDueDateForAllLocalGroups();
            this.getLocalUpdateRecordsStatus(true);
          } else {
            this.createLocalApproval();
            this.getLocalUpdateRecordsStatus(true);
          }
        }
        else {
          this.createLocalApproval();
          this.getLocalUpdateRecordsStatus(true);
        }
      }
    })
    //this.isReviewSubmitClicked$.subscribe((reviewStatus: boolean | undefined) => {
    //  switch (reviewStatus) {
    //    case true: {
    //      this.isLocalRecordsToUpdate$.subscribe((updateState: boolean | undefined) => {
    //        if (this.isLocalActionCompletd) {
    //          this.isLocalActionCompletd = false;
    //          let localpayload: LocalIFCGroupsDTO[] = [];
    //          this.localReviewersPayload$.subscribe((value: LocalIFCGroupsDTO[]) => {
    //            localpayload = value;
    //            return localpayload
    //          });
    //          switch (!isNaN(Number(localpayload[0].approvalsId))) {
    //            case true: {
    //              this.updateDueDateForAllLocalGroups();
    //              this.getLocalUpdateRecordsStatus(true);
    //              break;
    //            }
    //            case false: {
    //              this.createLocalApproval();
    //              this.getLocalUpdateRecordsStatus(true);
    //              break;
    //            }
    //            case undefined: {
    //              break;
    //            }
    //          }
    //        } else {
    //          return;
    //        }
    //      })
    //      break;
    //    }
    //    case false: {
    //      break;
    //    }
    //    case undefined: {
    //      break;
    //    }
    //  }
    //})
  }

  async createLocalApproval() {
    let responseStatus: boolean;
    let payload: LocalIFCGroupsDTO[] = [];
    let Proposal_ID = this.session.getItem(PROPOSAL_ID);
    this.localReviewersPayload$.subscribe((value: LocalIFCGroupsDTO[]) => {
      payload = value;
    });
    if(payload?.length == 0){      
      return;
    }
    const requests = payload.map((approver, idx) => {
      // Only create approval if approverEmail exists and is not empty
      if (approver?.approverEmail && approver.approverEmail.length > 0) {
        return this.apiService.createApprovals(Proposal_ID, approver);
      }
      // Return a dummy observable for missing approverEmail
      return of({ status: 200 });
    });

    combineLatest(requests).subscribe((result: any) => {
      this.isLocalActionCompletd = false;
      responseStatus = result.every((res: any) => Number(res.status) == 200 || Number(res.status) == 201);
      if (responseStatus) {
        this.message.success(LocalIFCCreateSuccess);
      } else {
        this.message.error(IFCDueDateUpdateError);
      }
    });
  }

  async updateDueDateForAllLocalGroups() {
    let responseStatus: boolean;
    let payload: LocalIFCGroupsDTO[] = [];
    this.localReviewersPayload$.subscribe((value: LocalIFCGroupsDTO[]) => {
      payload = value;
      return payload
    });
    if(payload?.length == 0){      
      return;
    }
    let proposal_ID = this.session.getItem(PROPOSAL_ID);
    const updateRequests = payload.map((approver, idx) => {
      // Only update approval if approverEmail exists and is not empty
      if (approver?.approverEmail 
          && approver.approverEmail.length > 0 
          && !isNaN(Number(approver?.approvalsId))) {
        return this.apiService.updateApprovals(proposal_ID, Number(approver?.approvalsId), approver);
      }
      // Return a dummy observable for missing approverEmail
      return of({ status: 200 });
    });
   
    combineLatest(updateRequests).subscribe((result: any) => {
      this.isLocalActionCompletd = false;
      responseStatus = result.every((res: any) => Number(res.status) == 200 || Number(res.status) == 201);
      if (responseStatus) {
        this.message.success(IFCDueDateUpdateSuccess);
      } else {
        this.message.error(IFCDueDateUpdateError);
      }
    });
  }

  updateLocalApproval(type: string) {
    let payload: LocalIFCGroupsDTO[] = [];
    let Proposal_ID = this.session.getItem(PROPOSAL_ID);
    this.ifcReviewersPayload$.subscribe((value: LocalIFCGroupsDTO[]) => {
      payload = value;
    });
    switch (type) {
      case LOCALLEGAL: {
        let payload_data: LocalIFCGroupsDTO = payload[0]
        payload_data.status = null;
        payload_data.comment = '';
        this.apiService.updateApprovals(Proposal_ID, Number(payload[0]?.approvalsId), payload_data).subscribe(legal => {
          if (legal.body) {
            console.log("this is legal response => ", legal);
          }
        });
        break;
      }
      case LOCALCOMPTROLLERS: {
        let payload_data: LocalIFCGroupsDTO = payload[1]
        payload_data.status = null;
        payload_data.comment = '';
        this.apiService.updateApprovals(Proposal_ID, Number(payload[1]?.approvalsId), payload_data).subscribe(comptroller => {
          if (comptroller.body) {
            console.log("this is comptroller response => ", comptroller);
          }
        });
        break;
      }
      case LOCALTAX: {
        let payload_data: LocalIFCGroupsDTO = payload[2]
        payload_data.status = null;
        payload_data.comment = '';
        this.apiService.updateApprovals(Proposal_ID, Number(payload[2]?.approvalsId), payload_data).subscribe(tax => {
          if (tax.body) {
            console.log("this is tax response => ", tax);
          }
        });
        break;
      }
      case LOCALTREASURY: {
        let payload_data: LocalIFCGroupsDTO = payload[3]
        payload_data.status = null;
        payload_data.comment = '';
        this.apiService.updateApprovals(Proposal_ID, Number(payload[3]?.approvalsId), payload_data).subscribe(treasury => {
          if (treasury.body) {
            console.log("this is treasury response => ", treasury);
          }
        });
        break;
      }
      case LOCALBU: {
        let payload_data: LocalIFCGroupsDTO = payload[4]
        payload_data.status = null;
        payload_data.comment = '';
        this.apiService.updateApprovals(Proposal_ID, Number(payload[4]?.approvalsId), payload_data).subscribe(bu => {
          if (bu.body) {
            console.log("this is treasury response => ", bu);
          }
        });
        break;
      }
      case LOCALOTHERS: {
        let payload_data: LocalIFCGroupsDTO = payload[5]
        payload_data.status = null;
        payload_data.comment = '';
        this.apiService.updateApprovals(Proposal_ID, Number(payload[5]?.approvalsId), payload_data).subscribe(others => {
          if (others.body) {
            console.log("this is treasury response => ", others);
          }
        });
        break;
      }
    }

  }
  //#endregion

}
